module.exports = __webpack_public_path__ + "static/media/favicon.1bd0dbcc.ico";